import React from 'react';
import Layout from '@common/layout';
import Header from '@common/header';
import Footer from '@common/footer';
import Content from '@common/content';
import { BookmarkCustomHead } from '@components/common/customHead';
import JobPostModalWrap from '@components/common/jobPostModal/JobPostModalWrap';
import MypageBookmark from '@components/mypage/bookmark';
import { useBookmarkStatus, useJobPostBookmarks } from '@repository/bookmark/useBookmark';

const MypageBookmarkPage = () => {
  const { refetch: refetch1 } = useJobPostBookmarks({ enabled: false });
  const { refetch: refetch2 } = useBookmarkStatus({ enabled: false });
  return (
    <Layout>
      <BookmarkCustomHead />
      <Header />
      <Content>
        <JobPostModalWrap
          beforeClose={() => {
            refetch1();
            refetch2();
          }}
        >
          <MypageBookmark />
        </JobPostModalWrap>
      </Content>
      <Footer />
    </Layout>
  );
};

export default MypageBookmarkPage;
